export default __webpack_public_path__ + "static/media/services_wedding.1ab3f558.jpg";